<template>
  <el-dialog
    class="awards-detail"
    title="学生获奖情况详情"
    :visible="detailShow"
    width="700px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <el-descriptions
      class="margin-top"
      title=""
      :column="2"
      border
      direction="horizontal"
    >
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          学生姓名
        </template>
        {{ medalDetail.studentName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-postcard"></i>
          年级班级 </template
        >{{ medalDetail.gradeName + medalDetail.className }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-trophy"></i>
          比赛名称
        </template>
        {{ medalDetail.competitionName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-medal"></i>
          获取奖项
        </template>
        {{ medalDetail.medal }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-school"></i>
          颁奖单位
        </template>
        {{ medalDetail.presentationUnit }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-time"></i>
          获奖时间
        </template>
        {{ medalDetail.gainDate }}
      </el-descriptions-item>
    </el-descriptions>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    detailShow: {
      type: Boolean,
      default: false,
    },
    medalDetail: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    dialogOpen() {},
    dialogClose() {
      this.$emit("update:detailShow", false);
    },
    // 时间戳转换
    getTime(timestamp) {
      let d = parseInt(timestamp / 60 / 60 / 24);
      // d = d < 10 ? "0" + d : d;
      let h = parseInt((timestamp / 60 / 60) % 24);
      // h = h < 10 ? "0" + h : h;
      let m = parseInt((timestamp / 60) % 60);
      // m = m < 10 ? "0" + m : m;
      let s = parseInt(timestamp % 60);
      // s = s < 10 ? "0" + s : s;
      return `${d}天${h}时${m}分`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./awardsDetail.scss";
</style>